import { FC, useContext } from "react";

import { useTranslate } from "../../../../hooks/useTranslate";
import { HeartsAnimationContext } from "../../context/heartsAnimationContext";
import { useDonationFirstStepSubmit } from "../DonationForm/useDonationFirststepSubmit";

import { HeartsFormButton } from "@/forms-design-system/HeartsFormButton";
import { ArrowRight } from "@/icons/outlined";

export const DonationFormV2CheckoutFooter: FC = () => {
  const { t } = useTranslate();
  const { onFirstStepSubmit, canSubmitFirstStep } = useDonationFirstStepSubmit();
  const { shouldDisplayHeartsAnimation, animationKey } = useContext(HeartsAnimationContext);

  return (
    <HeartsFormButton
      type="submit"
      endIcon={<ArrowRight />}
      onClick={onFirstStepSubmit}
      disabled={!canSubmitFirstStep}
      data-test="form-v2-step1-submit-button"
      animated={shouldDisplayHeartsAnimation}
      animationKey={animationKey}
      autoplay
      sx={(theme) => ({
        boxShadow: theme.shadows[2],
      })}
    >
      {t("donationForm", "continue")}
    </HeartsFormButton>
  );
};
